import { useState } from "react";
import { apiCall } from "../api";
import { useAuth } from "../context/AuthContext";
import { AuthLayout } from "./AuthLayout";

// Login Component
const Login = ({ onSwitch }) => {
  const [formData, setFormData] = useState({ email: '', password: '' });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [forgotMessage, setForgotMessage] = useState('');
  const { login, startGuestMode } = useAuth();

  const handleForgot = async () => {
    if (!formData.email) {
      setError('Escribe tu correo arriba y vuelve a dar clic en "Olvid\u00e9 mi contrase\u00f1a".');
      return;
    }
    setError('');
    try {
      const result = await apiCall('/auth/forgot-password', 'POST', { email: formData.email });
      setForgotMessage(result.message);
    } catch (err) {
      setError(err.detail || 'No pudimos enviar el correo. Intenta de nuevo.');
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      const result = await apiCall('/auth/login', 'POST', formData);
      login(result.landlord, result.token);
    } catch (err) {
      setError(err.detail || 'Error de inicio de sesi\u00f3n');
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthLayout title="Bienvenido de vuelta" subtitle="Entra a tu portal de propietario." onHome={() => onSwitch('landing')}>
        <form onSubmit={handleSubmit} className="text-left space-y-5">
          <div>
            <label className="block text-sm font-semibold text-amber-800 mb-1.5">Correo electr&oacute;nico</label>
            <input
              type="email"
              required
              value={formData.email}
              onChange={(e) => setFormData(prev => ({ ...prev, email: e.target.value }))}
              className="w-full px-4 py-3 border border-amber-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-amber-500 focus:border-amber-500 bg-white"
              placeholder="tu@empresa.com"
            />
          </div>

          <div>
            <label className="block text-sm font-semibold text-amber-800 mb-1.5">Contrase&ntilde;a</label>
            <input
              type="password"
              required
              value={formData.password}
              onChange={(e) => setFormData(prev => ({ ...prev, password: e.target.value }))}
              className="w-full px-4 py-3 border border-amber-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-amber-500 focus:border-amber-500 bg-white"
              placeholder=""
            />
          </div>

          <div className="text-right -mt-3">
            <button
              type="button"
              onClick={handleForgot}
              className="text-sm text-amber-800/80 hover:text-amber-900 hover:underline"
            >
              Olvid&eacute; mi contrase&ntilde;a
            </button>
          </div>

          {forgotMessage && (
            <div className="bg-emerald-50 border border-emerald-200 text-emerald-800 px-4 py-3 rounded-lg text-sm">{forgotMessage}</div>
          )}

          {error && (
            <div className="bg-red-50 border-l-4 border-red-500 text-red-700 px-5 py-4 rounded-lg shadow-sm">
              <div className="flex">
                <svg className="w-5 h-5 mr-3 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clipRule="evenodd" />
                </svg>
                <span className="font-semibold">{error}</span>
              </div>
            </div>
          )}

          <button
            type="submit"
            disabled={loading}
            className="w-full bg-gradient-to-r from-amber-500 to-amber-600 text-white py-3.5 px-6 rounded-lg hover:from-amber-600 hover:to-amber-700 shadow-md disabled:opacity-50 font-bold text-base transition-colors"
          >
            {loading ? (
              <div className="flex items-center justify-center">
                <svg className="animate-spin -ml-1 mr-3 h-6 w-6 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                  <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                  <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                </svg>
                Iniciando Sesi&oacute;n...
              </div>
            ) : 'Iniciar sesi\u00f3n'}
          </button>
        </form>

        <div className="mt-6 pt-6 border-t border-amber-100 space-y-3 text-center">
          <p className="text-sm text-amber-800/80">
            &iquest;A&uacute;n no tienes cuenta?{' '}
            <button type="button" onClick={() => onSwitch('register')} className="font-bold text-amber-700 hover:text-amber-800 hover:underline">Crear cuenta gratis</button>
          </p>
          <button
            type="button"
            onClick={startGuestMode}
            className="inline-flex items-center gap-2 text-sm font-semibold text-amber-900 hover:text-amber-700"
          >
            <svg className="w-4 h-4 text-amber-600" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 10V3L4 14h7v7l9-11h-7z" />
            </svg>
            Consulta r&aacute;pida sin cuenta
          </button>
        </div>
    </AuthLayout>
  );
};

export { Login };
